import { Typography, Box } from '@mui/material';

import FormBuilder from '../../form-builder';
import { CreateCnpjStepFormProps } from './create-cnpj-step-form.types';

export const CreateCnpjStepTwo: React.FC<CreateCnpjStepFormProps> = ({
    label,
    sectionIndex,
    stepKey,
    inputs,
    errors,
    touched,
    values,
    setFieldValue,
    getFieldProps,
}) => {

    return (
        <Box style={{ margin: 15 }}>
            <Typography color={'#2D2935'} marginBottom={4} marginTop={sectionIndex !== 0 ? 4 : 2} fontSize={24} fontWeight={600} lineHeight={2} letterSpacing={0.2}>
                {label}
            </Typography>
            <FormBuilder
                errors={errors}
                touched={touched}
                values={values}
                setFieldValue={setFieldValue}
                inputs={inputs}
                getFieldProps={getFieldProps}
            />
        </Box>
    )
}